import type { LinkIconPlacement as CKLinkIconPlacement } from '@property.com.au/ui-kit';
import {
  AirconReverseLg,
  AlarmMd,
  AwardMd,
  BalconyLg,
  BathMd,
  ButtonIconPlacement,
  CarportLg,
  CarSpaceOpenLg,
  CouchLg,
  CourtyardLg,
  DeckLg,
  DeskMd,
  DishwasherLg,
  DogMd,
  DuctedCoolingLg,
  DuctedHeatingLg,
  DuctedVacuumLg,
  ElectricHeatingLg,
  ElectricHotWaterLg,
  EvaporativeCoolingLg,
  FenceLg,
  FirePlaceLg,
  FloorboardsLg,
  FloorplanMd,
  GarageLg,
  GasHotWaterLg,
  GasLg,
  GreyWaterSystemLg,
  GymLg,
  HammerLg,
  HeatPumpLg,
  HomeMd,
  HydronicHeatingLg,
  IntercomLg,
  LandSizeMd,
  LinkIconPlacement,
  MoreMd,
  RemoteGarageLg,
  RemoteLg,
  RumpusRoomLg,
  SecureParkingLg,
  ShedLg,
  ShowerLg,
  SnowflakeMd,
  SolarHotWaterLg,
  SolarPanelsLg,
  SpaInsideLg,
  SpaOutdoorLg,
  SplitSystemCoolingLg,
  SplitSystemHeatingLg,
  StarMd,
  SuccessMd,
  SunMd,
  SwimmingPoolIngroundMd,
  SwimmingPoolOvergroundLg,
  TennisBallLg,
  ToiletLg,
  WardrobeLg,
  WaterTankLg,
} from '@property.com.au/ui-kit';
import { ReactElement } from 'react';
export const mapLinkIconPlacement = (
  placement: LinkIconPlacement | ButtonIconPlacement | null | undefined,
): CKLinkIconPlacement => {
  switch (placement) {
    case 'right':
      return 'right';
    case 'left':
    default:
      return 'left';
  }
};

export const mapIconIdToJSXElement = (
  iconId: string,
  title?: string,
  id?: string,
): ReactElement => {
  switch (iconId) {
    case 'DeskMd':
      return <DeskMd title={title} id={id} />;
    case 'DishwasherLg':
      return <DishwasherLg title={title} id={id} />;
    case 'WardrobeLg':
      return <WardrobeLg title={title} id={id} />;
    case 'GymLg':
      return <GymLg title={title} id={id} />;
    case 'FloorplanMd':
      return <FloorplanMd title={title} id={id} />;
    case 'HammerLg':
      return <HammerLg title={title} id={id} />;
    case 'SpaInsideLg':
      return <SpaInsideLg title={title} id={id} />;
    case 'RumpusRoomLg':
      return <RumpusRoomLg title={title} id={id} />;
    case 'FloorBoardsLg':
      return <FloorboardsLg title={title} id={id} />;
    case 'RemoteLg':
      return <RemoteLg title={title} id={id} />;
    case 'DuctedVacuumLg':
      return <DuctedVacuumLg title={title} id={id} />;
    case 'GasLg':
      return <GasLg title={title} id={id} />;
    case 'SplitSystemHeatingLg':
      return <SplitSystemHeatingLg title={title} id={id} />;
    case 'SplitSystemCoolingLg':
      return <SplitSystemCoolingLg title={title} id={id} />;
    case 'EvaporativeCoolingLg':
      return <EvaporativeCoolingLg title={title} id={id} />;
    case 'HydronicHeatingLg':
      return <HydronicHeatingLg title={title} id={id} />;
    case 'DuctedHeatingLg':
      return <DuctedHeatingLg title={title} id={id} />;
    case 'DuctedCoolingLg':
      return <DuctedCoolingLg title={title} id={id} />;
    case 'AirconReverseLg':
      return <AirconReverseLg title={title} id={id} />;
    case 'SnowflakeMd':
      return <SnowflakeMd title={title} id={id} />;
    case 'FirePlaceLg':
      return <FirePlaceLg title={title} id={id} />;
    case 'ElectricHeatingLg':
      return <ElectricHeatingLg title={title} id={id} />;
    case 'GasHotWaterLg':
      return <GasHotWaterLg title={title} id={id} />;
    case 'ElectricHotWaterLg':
      return <ElectricHotWaterLg title={title} id={id} />;
    case 'AlarmMd':
      return <AlarmMd title={title} id={id} />;
    case 'IntercomLg':
      return <IntercomLg title={title} id={id} />;
    case 'BalconyLg':
      return <BalconyLg title={title} id={id} />;
    case 'DeckLg':
      return <DeckLg title={title} id={id} />;
    case 'CourtyardLg':
      return <CourtyardLg title={title} id={id} />;
    case 'SunMd':
      return <SunMd title={title} id={id} />;
    case 'ShedLg':
      return <ShedLg title={title} id={id} />;
    case 'FenceLg':
      return <FenceLg title={title} id={id} />;
    case 'TennisBallLg':
      return <TennisBallLg title={title} id={id} />;
    case 'SwimmingPoolOvergroundLg':
      return <SwimmingPoolOvergroundLg title={title} id={id} />;
    case 'SwimmingPoolIngroundMd':
      return <SwimmingPoolIngroundMd title={title} id={id} />;
    case 'SpaOutdoorLg':
      return <SpaOutdoorLg title={title} id={id} />;
    case 'RemoteGarageLg':
      return <RemoteGarageLg title={title} id={id} />;
    case 'SecureParkingLg':
      return <SecureParkingLg title={title} id={id} />;
    case 'SolarPanelsLg':
      return <SolarPanelsLg title={title} id={id} />;
    case 'SolarHotWaterLg':
      return <SolarHotWaterLg title={title} id={id} />;
    case 'HeatPumpLg':
      return <HeatPumpLg title={title} id={id} />;
    case 'WaterTankLg':
      return <WaterTankLg title={title} id={id} />;
    case 'GreyWaterSystemLg':
      return <GreyWaterSystemLg title={title} id={id} />;
    case 'DogMd':
      return <DogMd title={title} id={id} />;
    case 'SuccessMd':
      return <SuccessMd title={title} id={id} />;
    case 'CouchLg':
      return <CouchLg title={title} id={id} />;
    case 'HomeMd':
      return <HomeMd title={title} id={id} />;
    case 'LandSizeMd':
      return <LandSizeMd title={title} id={id} />;
    case 'GarageLg':
      return <GarageLg title={title} id={id} />;
    case 'CarportLg':
      return <CarportLg title={title} id={id} />;
    case 'CarSpaceOpenLg':
      return <CarSpaceOpenLg title={title} id={id} />;
    case 'ToiletLg':
      return <ToiletLg title={title} id={id} />;
    case 'StarMd':
      return <StarMd title={title} id={id} />;
    case 'BathMd':
      return <BathMd title={title} id={id} />;
    case 'ShowerLg':
      return <ShowerLg title={title} id={id} />;
    case 'AwardMd':
      return <AwardMd title={title} id={id} />;
    case 'MoreMd':
      return <MoreMd title={title} id={id} />;
    default:
      return <SuccessMd title={title} id={id} />;
  }
};
